import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  maxSize,
  minSize,
} from 'rn-responsive-styles';

const shadow = (shadowColor: string) => ({
  shadowColor: shadowColor,
  shadowOffset: {
    width: 0,
    height: 4,
  },
  shadowOpacity: 1,
  shadowRadius: 8,

  elevation: 5,
});

export const backgroundColor = (index: number, theme: ITheme) => {
  return {
    backgroundColor:
      index % 2 === 0 ? theme.colors.dirtyWhite : theme.colors.white,
  };
};

export default (props: ITheme) =>
  CreateResponsiveStyle(
    {
      container: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'flex-end',
      },
      dotsStyle: {
        height: 38,
        width: 10,
        resizeMode: 'contain',
      },

      leftContainer: {
        width: 250,
        gap: 10,
        flexDirection: 'row',
        paddingLeft: 25,
        alignSelf: 'flex-start',
        paddingTop: 8,
        borderRightWidth: 1,
        borderBottomWidth: 1,
        borderColor: props.colors.extraLight,
        height: '100%',
      },

      timeTextStyle: {
        fontSize: 16,
        color: props.colors.black,
        ...props.typography.interRegular,
      },
      userNameTextStyle: {
        fontSize: 16,
        lineHeight: 16,
        color: props.colors.black,
        ...props.typography.interMedium,
      },

      transcriptionTextStyle: {
        fontSize: 14,
        color: props.colors.black,
        ...props.typography.notoSansRegular,
      },

      rightContainer: {
        flex: 1,
        paddingLeft: 30,
        paddingVertical: 11,
        alignItems: 'flex-start',
        borderBottomWidth: 1,
        borderColor: props.colors.extraLight,
      },
      timeStyle: {
        flexDirection: 'column',
      },
    },
    {
      [maxSize(DEVICE_SIZES.EXTRA_SMALL_DEVICE)]: {
        container: {
          alignItems: 'flex-start',
          flexDirection: 'column',
          marginHorizontal: 2,
          marginBottom: 12,
          backgroundColor: props.colors.white,
          borderRadius: 12,
          ...shadow(props.colors.shadowColor),
        },
        leftContainer: {
          flexDirection: 'column',
          height: 50,
          paddingLeft: 16,
          backgroundColor: props.colors.white,
          borderBottomWidth: 0,
          borderRadius: 12,
          borderRightWidth: 0,
        },
        rightContainer: {
          flex: 1,
          borderBottomWidth: 0,
          paddingLeft: 16,
          paddingRight: 16,
          marginTop: 2,
          borderRadius: 12,
          backgroundColor: props.colors.white,
          borderColor: props.colors.extraLight,
        },
        timeStyle: {
          flexDirection: 'row',
          marginBottom: 8,
        },
        dotsStyle: {
          display: 'none',
        },
      },
    },
  )();
